export default {
  ziweiMaj: '紫微',
  tianjiMaj: '天機',
  taiyangMaj: '太陽',
  wuquMaj: '武曲',
  tiantongMaj: '天同',
  lianzhenMaj: '廉貞',
  tianfuMaj: '天府',
  taiyinMaj: '太陰',
  tanlangMaj: '貪狼',
  jumenMaj: '巨門',
  tianxiangMaj: '天相',
  tianliangMaj: '天梁',
  qishaMaj: '七殺',
  pojunMaj: '破軍',
  zuofuMin: '左輔',
  youbiMin: '右弼',
  wenchangMin: '文昌',
  wenquMin: '文曲',
  lucunMin: '祿存',
  tianmaMin: '天馬',
  qingyangMin: '擎羊',
  tuoluoMin: '陀羅',
  huoxingMin: '火星',
  lingxingMin: '鈴星',
  tiankuiMin: '天魁',
  tianyueMin: '天鉞',
  dikongMin: '地空',
  dijieMin: '地劫',
  tiankong: '天空',
  tianxing: '天刑',
  tianyao: '天姚',
  jieshen: '解神',
  yinsha: '陰煞',
  tianxi: '天喜',
  tianguan: '天官',
  tianfu: '天福',
  tianku: '天哭',
  tianxu: '天虛',
  longchi: '龍池',
  fengge: '鳳閣',
  hongluan: '紅鸞',
  guchen: '孤辰',
  guasu: '寡宿',
  feilian: '蜚廉',
  posui: '破碎',
  taifu: '台輔',
  fenggao: '封誥',
  tianwu: '天巫',
  tianyue: '天月',
  santai: '三台',
  bazuo: '八座',
  engguang: '恩光',
  tiangui: '天貴',
  tiancai: '天才',
  tianshou: '天壽',
  jiekong: '截空',
  xunzhong: '旬中',
  xunkong: '旬空',
  kongwang: '空亡',
  jielu: '截空',
  yuede: '月德',
  tianshang: '天傷',
  tianshi: '天使',
  tianchu: '天廚',
  changsheng: '長生',
  muyu: '沐浴',
  guandai: '冠帶',
  linguan: '臨官',
  diwang: '帝旺',
  shuai: '衰',
  bing: '病',
  si: '死',
  mu: '墓',
  jue: '絕',
  tai: '胎',
  yang: '養',
  boshi: '博士',
  lishi: '力士',
  qinglong: '青龍',
  xiaohao: '小耗',
  jiangjun: '將軍',
  zhoushu: '奏書',
  faylian: '飛廉',
  xishen: '喜神',
  bingfu: '病符',
  dahao: '大耗',
  fubing: '伏兵',
  guanfu: '官府',
  suijian: '歲建',
  huiqi: '晦氣',
  sangmen: '喪門',
  guansuo: '貫索',
  gwanfu: '官符',
  longde: '龍德',
  baihu: '白虎',
  tiande: '天德',
  diaoke: '弔客',
  jiangxing: '將星',
  panan: '攀鞍',
  suiyi: '歲驛',
  xiishen: '息神',
  huagai: '華蓋',
  jiesha: '劫煞',
  zhaisha: '災煞',
  tiansha: '天煞',
  zhibei: '指背',
  xianchi: '咸池',
  yuesha: '月煞',
  wangshen: '亡神',
  yunkui: '限の魁',
  yunyue: '限の钺',
  yunchang: '限の昌',
  yunqu: '限の曲',
  yunluan: '限の鸾',
  yunxi: '限の喜',
  yunlu: '限の祿',
  yunyang: '限の羊',
  yuntuo: '限の陀',
  yunma: '限の馬',
  liukui: '年の魁',
  liuyue: '年の钺',
  liuchang: '年の昌',
  liuqu: '年の曲',
  liuluan: '年の鸾',
  liuxi: '年の喜',
  liulu: '年の祿',
  liuyang: '年の羊',
  liutuo: '年の陀',
  liuma: '年の馬',
  nianjie: '年の解',
  yuekui: '月の魁',
  yueyue: '月の钺',
  yuechang: '月の昌',
  yuequ: '月の曲',
  yueluan: '月の鸾',
  yuexi: '月の喜',
  yuelu: '月の祿',
  yueyang: '月の羊',
  yuetuo: '月の陀',
  yuema: '月の馬',
  rikui: '日の魁',
  riyue: '日の钺',
  richang: '日の昌',
  riqu: '日の曲',
  riluan: '日の鸾',
  rixi: '日の喜',
  rilu: '日の祿',
  riyang: '日の羊',
  rituo: '日の陀',
  rima: '日の馬',
  shikui: '時の魁',
  shiyue: '時の钺',
  shichang: '時の昌',
  shiqu: '時の曲',
  shiluan: '時の鸾',
  shixi: '時の喜',
  shilu: '時の祿',
  shiyang: '時の羊',
  shituo: '時の陀',
  shima: '時の馬',
} as const;
